/* ============================================
   THE PRINT LOFT — Glazing Add-On Module
   Handles: glazing visibility, pre-rendered price
   swapping, variant ID tracking, floating bar
   price mirroring.

   RULE: This file NEVER formats or computes prices.
   All prices come from Liquid-rendered, Bucks-converted
   DOM elements. We only read, copy, or toggle visibility.
============================================ */

document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  /* ─── HELPERS ─── */
  function $id(id) { return document.getElementById(id); }

  /* Get the selected option value from a product-form input wrapper.
     Handles both button/radio pickers (input:checked) and dropdown pickers
     (<select>), which Shopify's Theme Editor can swap between. */
  function getSelectedValue(wrapper) {
    if (!wrapper) return '';
    var checked = wrapper.querySelector('input:checked');
    if (checked) return checked.value;
    var select = wrapper.querySelector('select');
    if (select) return select.value;
    return '';
  }

  /* Find the .product-form__input wrapper whose label matches a regex. */
  function findWrapperByLabel(labelRegex) {
    var match = null;
    document.querySelectorAll('.product-form__input').forEach(function (fs) {
      var legend = fs.querySelector('.form__label, legend, label');
      if (legend && labelRegex.test(legend.textContent)) match = fs;
    });
    return match;
  }

  /* ─── READ PRE-RENDERED GLAZING DATA ─── */

  var priceDataEl = $id('tpl-glazing-price-data');
  if (!priceDataEl) return; /* No glazing block on this page */

  var entries = priceDataEl.querySelectorAll('[data-glazing-size]');
  var glazingSizes = {};
  entries.forEach(function (el) {
    glazingSizes[el.dataset.glazingSize] = {
      variantId: el.dataset.glazingVariantId,
      priceHTML: el.innerHTML /* Already Bucks-converted */
    };
  });

  var sizeKeys = Object.keys(glazingSizes);
  if (!sizeKeys.length) return; /* No variants found */

  /* No module-level state needed — D-5 made the container's
     data-current-variant-id attribute the single source of truth. */

  /* ─── GLAZING VISIBILITY ───
     Show glazing checkbox only when a frame (not Unframed) is selected.
     Uses event delegation so it survives Dawn re-renders. */

  function updateGlazingVisibility() {
    var container = $id('tpl-uv-glazing-container');
    if (!container) return;

    /* F-3: data-attribute selector first; label-regex as defensive fallback
       for any non-standard wrappers that may not carry the attribute. */
    var frameWrapper = document.querySelector('[data-option-name="Framing"]')
                    || findWrapperByLabel(/frame|framing|style/i);
    if (!frameWrapper) {
      container.hidden = true;
      return;
    }

    var frameValue = getSelectedValue(frameWrapper);
    var frameRequiresGlazing = !!(frameValue && !/unframed/i.test(frameValue));

    /* HIGH-fix: only show when BOTH the frame requires glazing AND we have
       a valid glazing variant for the current size (set by syncGlazingToSize).
       Without this guard, a size with no glazing mapping would still show the
       checkbox; ticking it would silently fail at /cart/add. */
    var hasValidGlazingVariant = !!container.dataset.currentVariantId;

    if (frameRequiresGlazing && hasValidGlazingVariant) {
      container.hidden = false;
    } else {
      container.hidden = true;
      var cb = $id('tpl-uv-glazing-checkbox');
      if (cb) cb.checked = false;
    }
  }

  /* ─── GLAZING SIZE SYNC ───
     When user changes size, copy the pre-rendered price HTML
     for that size into the visible price label. */

  function matchSize(optionValue) {
    if (!optionValue) return '';
    var handleized = optionValue.toLowerCase()
      .replace(/\s*[\(\[].*$/, '')
      .replace(/\s*-\s+\d.*$/, '')
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

    /* Direct match */
    if (glazingSizes[handleized]) return handleized;

    /* Production keys are FULL Liquid-handleized variant titles (e.g.
       "x-large-60-90cm", "small-square-30x30cm"). Strip each key's trailing
       dimension segment (first "-<digit>" onward) and require exact
       equality — first-word matching is unsafe ("small-square" vs "small"). */
    for (var i = 0; i < sizeKeys.length; i++) {
      if (sizeKeys[i].replace(/-\d.*$/, '') === handleized) return sizeKeys[i];
    }
    return '';
  }

  function syncGlazingToSize() {
    /* F-3: data-attribute selector first; label-regex as defensive fallback. */
    var sizeWrapper = document.querySelector('[data-option-name="Size"]')
                   || findWrapperByLabel(/size/i);
    var sizeValue = getSelectedValue(sizeWrapper);
    var container = $id('tpl-uv-glazing-container');

    var sizeName = matchSize(sizeValue);
    var match = glazingSizes[sizeName];
    if (!match) {
      /* Size doesn't map to any glazing variant. Clear the variant-id
         attribute so updateGlazingVisibility() keeps the container hidden —
         prevents the customer from ticking a checkbox that would then
         silently fail at /cart/add (allowlist would reject the empty id). */
      if (container) container.dataset.currentVariantId = '';
      return;
    }

    /* Update visible price label */
    var priceEl = $id('tpl-uv-glazing-price');
    if (priceEl) priceEl.innerHTML = match.priceHTML;

    /* D-5: write the variant ID to the container's data attribute so the
       cart bridge can read it at submit time without depending on event
       ordering (the previous CustomEvent path had a race window where
       a deep-link page-load could dispatch before the user's first click). */
    if (container) container.dataset.currentVariantId = match.variantId;

    /* Tell Bucks to re-scan (no-op for INR visitors) */
    ((window || {}).bucksCC || {}).reConvert && bucksCC.reConvert();
  }

  /* ─── FLOATING BAR PRICE MIRRORING ───
     The floating bar shows the variant price only (no glazing addition).
     We mirror the main price element, which Dawn + Bucks already set correctly.
     Synced via MutationObserver on Dawn's Section Rendering re-renders. */

  function mirrorFloatingBarPrice() {
    var mainPrice = document.querySelector('.price__regular .price-item--regular');
    var floatingPrice = $id('tpl-floating-price');
    if (!mainPrice || !floatingPrice) return;
    floatingPrice.innerHTML = mainPrice.innerHTML;

    /* Tell Bucks to re-scan the floating bar */
    ((window || {}).bucksCC || {}).reConvert && bucksCC.reConvert();
  }

  /* rAF debounce: rapid variant clicks coalesce into a single mirror per frame.
     Prevents N queued callbacks from N clicks (was: setTimeout 150/500/1000). */
  var mirrorScheduled = false;
  function scheduleMirror() {
    if (mirrorScheduled) return;
    mirrorScheduled = true;
    requestAnimationFrame(function () {
      mirrorFloatingBarPrice();
      mirrorScheduled = false;
    });
  }

  /* Single MutationObserver watches Dawn's price wrapper for re-renders.
     Reference held at module level so we can disconnect on section unload. */
  var priceWrapper = document.querySelector('[id^="price-"][role="status"]');
  var priceObserver = null;
  if (priceWrapper) {
    priceObserver = new MutationObserver(scheduleMirror);
    priceObserver.observe(priceWrapper, { childList: true, subtree: true });
  }

  /* Cleanup: disconnect observer when Shopify tears down this section
     (theme editor re-order, SPA navigation). Prevents memory growth. */
  document.addEventListener('shopify:section:unload', function (e) {
    if (!priceObserver) return;
    if (e.target && e.target.querySelector && e.target.querySelector('[id^="price-"][role="status"]')) {
      priceObserver.disconnect();
      priceObserver = null;
    }
  });

  /* ─── EVENT LISTENERS ─── */

  /* Variant radio/select changes — delegation survives Dawn re-renders.
     The MutationObserver above handles mirror on Dawn's re-render;
     scheduleMirror() coalesces rapid clicks into one rAF tick.

     F-5: glazing only depends on Size (price) and Framing (visibility).
     Skip Finish changes to avoid 3 wasted DOM-walks per click. */
  function isGlazingRelevantOption(target) {
    if (!target) return false;
    var wrapper = target.closest('[data-option-name]');
    if (!wrapper) return true; /* fallback for any wrapper without the attr */
    var name = wrapper.getAttribute('data-option-name');
    return name === 'Size' || name === 'Framing';
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest('.product-form__input')) return;
    if (e.target.id === 'tpl-uv-glazing-checkbox') return;
    if (!isGlazingRelevantOption(e.target)) {
      /* Floating-bar price still needs to mirror on any variant change
         (Finish + Frame both change variant.price); only the glazing
         size/visibility recompute is unnecessary. */
      scheduleMirror();
      return;
    }

    syncGlazingToSize();
    updateGlazingVisibility();
    scheduleMirror();
  });

  /* PubSub variant change — immediate, before Dawn re-renders */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event.data && event.data.variant;
      if (!variant) return;

      syncGlazingToSize();
      updateGlazingVisibility();
    });
  }

  /* ─── INITIAL STATE ─── */

  syncGlazingToSize();
  updateGlazingVisibility();
});
